import React from 'react';
import { SortDirection } from '../../hooks/useTableSort';

interface SortableColumnHeaderProps {
  label: string;
  columnKey: string;
  currentColumn: string | null;
  direction: SortDirection;
  onSort: (column: string) => void;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const SortableColumnHeader: React.FC<SortableColumnHeaderProps> = ({
  label,
  columnKey,
  currentColumn,
  direction,
  onSort,
  style,
  children,
}) => {
  const isActive = currentColumn === columnKey;
  const arrow = isActive ? (direction === 'asc' ? '↑' : '↓') : '';

  return (
    <div
      onClick={() => onSort(columnKey)}
      style={{
        cursor: 'pointer',
        userSelect: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        borderRadius: 8,
        padding: '4px 8px',
        margin: '-4px -8px',
        transition: 'background-color 0.15s ease',
        ...style,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      {children || label}
      {arrow && (
        <span style={{ fontSize: '0.85em', opacity: 0.8 }}>{arrow}</span>
      )}
    </div>
  );
};
